var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('pre',[_c('code',[_vm._v(_vm._s('loco'))])]),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.$ability))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }